import React, { useEffect, useState } from "react";
import LayoutHeader from "../../inc/LayoutHeader";
import LayoutFooter from "../../inc/LayoutFooter";
import { useNavigate } from "react-router-dom";
import {
  Layout,
  Card,
  Button,
  Form,
  Select,
  DatePicker,
  Table,
  InputNumber,
  Row,
  Col,
  Spin,
} from "antd";
import {
  RollbackOutlined,
  PlusOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";

import { getAPI, postAPI, displayMessage } from "../../../utils/common";
import { SUCCESS_MESSAGE, ERROR_MSG_TYPE } from "../../../constants/messages";
import {
  ALL_VENDOR,
  ALL_LAUNDRY_ITEM,
  CREATE_LAUNDRY_OUT,
} from "../../../constants/api";

const { Content } = Layout;

function LaundryOutAdd() {
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const [vendors, setVendors] = useState([]);
  const [items, setItems] = useState([]);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  // Load vendors & items
  useEffect(() => {
    getAPI(ALL_VENDOR, (res) => {
      if (res.status) setVendors(res.data);
    });

    getAPI(ALL_LAUNDRY_ITEM, (res) => {
      if (res.status) setItems(res.data);
    });
  }, []);

  // Add empty row
  const addRow = () => {
    setRows([...rows, { item_id: null, qty_sent: 1 }]);
  };

  // Remove row
  const removeRow = (index) => {
    const updated = [...rows];
    updated.splice(index, 1);
    setRows(updated);
  };

  // Update row data
  const updateRow = (index, field, value) => {
    const updated = [...rows];
    updated[index][field] = value;
    setRows(updated);
  };

  // Submit
  const submitData = (values) => {
    if (rows.length === 0) {
      displayMessage(ERROR_MSG_TYPE, "Please add at least one item");
      return;
    }

    setLoading(true);

    const payload = {
      vendor_id: values.vendor_id,
      out_date: dayjs(values.out_date).format("YYYY-MM-DD"),
      items: rows,
    };

    postAPI(
      CREATE_LAUNDRY_OUT,
      payload,
      (res) => {
        setLoading(false);
        if (res.status) {
          displayMessage(SUCCESS_MESSAGE, res.message);
          navigate("/laundry/out");
        } else {
          displayMessage(ERROR_MSG_TYPE, res.message);
        }
      },
      () => {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, "Unable to create laundry out");
      }
    );
  };

  // Table columns
  const columns = [
    {
      title: "Item",
      render: (_, record, index) => (
        <Select
          placeholder="Select Item"
          style={{ width: "100%" }}
          value={record.item_id}
          onChange={(val) => updateRow(index, "item_id", val)}
        >
          {items.map((i) => (
            <Select.Option key={i.id} value={i.id}>
              {i.name}
            </Select.Option>
          ))}
        </Select>
      ),
    },
    {
      title: "Qty Sent",
      render: (_, record, index) => (
        <InputNumber
          min={1}
          value={record.qty_sent}
          onChange={(val) => updateRow(index, "qty_sent", val)}
        />
      ),
    },
    {
      title: "Action",
      render: (_, __, index) => (
        <Button danger onClick={() => removeRow(index)}>
          <DeleteOutlined />
        </Button>
      ),
    },
  ];

  return (
    <Layout>
      <LayoutHeader />

      <Content>
        <Card
          title="Laundry Out (Send to Vendor)"
          extra={
            <Button onClick={() => navigate(-1)} type="primary" ghost>
              <RollbackOutlined />
            </Button>
          }
        >
          <Spin spinning={loading}>
            <Form form={form} layout="vertical" onFinish={submitData}>
              <Row gutter={[16, 16]}>
                <Col span={8}>
                  <Form.Item
                    name="vendor_id"
                    label="Vendor"
                    rules={[{ required: true }]}
                  >
                    <Select placeholder="Select Vendor">
                      {vendors.map((v) => (
                        <Select.Option key={v.id} value={v.id}>
                          {v.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={8}>
                  <Form.Item
                    name="out_date"
                    label="Out Date"
                    rules={[{ required: true }]}
                  >
                    <DatePicker />
                  </Form.Item>
                </Col>
              </Row>

              <Card
                size="small"
                title="Items"
                extra={
                  <Button onClick={addRow} type="dashed">
                    <PlusOutlined /> Add Item
                  </Button>
                }
              >
                <Table
                  columns={columns}
                  dataSource={rows}
                  pagination={false}
                  rowKey={(_, index) => index}
                />
              </Card>

              <Row style={{ marginTop: 20 }}>
                <Col span={24}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                    style={{ float: "right" }}
                  >
                    Submit
                  </Button>
                </Col>
              </Row>
            </Form>
          </Spin>
        </Card>
      </Content>

      <LayoutFooter />
    </Layout>
  );
}

export default LaundryOutAdd;
